import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useBreadcrumb } from "hooks/useBreadcrumb";
import { isFlagEnabled } from "js/utilities";
import Toast from "components/General/Toast";
import GeneralPurposeDialog from "components/General/GeneralPurposeDialog";
import ManagePaymentCard from "components/ManegPayment/ManagePaymentCard";
import EverlakeLoadingOverlay from "components/General/EverlakeLoadingOverlay";
import getPaymentProfile from "service/paymentServices/GetPaymentProfile/index";
import AddPaymentMethod from "components/ModalDialogs/AddPaymentMethod";

export default function ManagePayment() {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.user);
  const { policies } = useSelector((state) => state.data);
  const [autoPaymentData, setAutoPaymentData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isUpdated, setIsUpdated] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [title, setTitle] = useState(false);
  const [message, setMessage] = useState(false);
  const [addPaymentModal, setAddPaymentModal] = useState(false);
  const [toastDetail, setToastDetail] = useState({
    type: undefined,
    title: "",
    message: "",
  });

  useEffect(() => {
    let creditCardDetails;
    setIsLoading(true);
    creditCardDetails = policies.filter(
      (p) => p?.billingTypeCode === "06" && p?.creditCard?.recurringReferenceId
    );
    getPaymentProfile({
      policies: creditCardDetails,
      UserId: user?.userId,
    })
      .then((response) => {
        setIsLoading(false);
        let paymentProfile = [];
        if (response?.length > 0) {
          response?.map((p) => {
            if (p?.paymentProfileId) {
              paymentProfile.push({
                id: p.userId,
                isDefault: false,
                type: "Credit Card",
                accountNumber: `****-****-****-${p.cardNumber}`,
                ownerName: p.cardHolderName,
                expDate: `${p.cardExpiryMonth}/${p.cardExpiryYear}`,
                cardType: p.cardType,
                cardStatus: p.cardStatus,
                paymentProfileId: p.paymentProfileId,
                userId: p.userId,
              });
            }
          });
          setAutoPaymentData(paymentProfile);
        } else setAutoPaymentData([]);
      })
      .catch((error) => {
        console.error(t("AuthCustomerPaymentMethods-error-message-1"), error);
        setMessage(t("AuthCustomerPaymentMethods-error-message-1"));
        setTitle(t("AuthCustomerPaymentMethods-error-message-2"));
        setOpenDialog(true);
        setIsLoading(false);
      });
  }, [policies, user, isUpdated]);

  useBreadcrumb([
    { name: t("CustomerManagePayment-home"), url: "/policies" },
    { name: t("CustomerManagePayment-payments"), url: "/payment" },
    { name: t("CustomerManagePayment-manage-payment-methds"), url: "#" },
  ]);

  return (
    <>
      <EverlakeLoadingOverlay isLoading={isLoading}>
        {toastDetail.type && (
          <Toast
            isErrorToast={isUpdated}
            type={toastDetail?.type}
            title={toastDetail?.title}
            message={toastDetail?.message}
          />
        )}
        <div className="container ui-component-spacing">
          <h1 className={toastDetail?.type === undefined ? "mt-0" : "mt-6"}>
            {t("ManagePaymentMethods-title")}
          </h1>
          {isFlagEnabled(
            "ENABLE_MANAGE_PAYMENT_METHODS_PAGE_ADD_PAYMENT_METHOD_BUTTON"
          ) && (
            <div className="flex justify-end mb-4">
              <button
                className="ui-btn-primary ui-btn-min-w ml-2"
                onClick={() => {
                  setAddPaymentModal(true);
                }}
              >
                {t("ManagePaymentMethods-addPaymentMethodButton")}
                <span className="sr-only">
                  {t("ManagePaymentMethods-addPaymentMethodButton")}
                </span>
              </button>
            </div>
          )}
          {autoPaymentData?.length === 0 && !isLoading ? (
            <div className="border border-dashed border-ui-gray p-6 my-6">
              <div className="text-center">
                <div className="text-xl font-bold">
                  {t("ManagePaymentMethods-no-CreditCards")}
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="ui-paymethod-grid">
                <div className="ui-grid-cards">
                  {autoPaymentData.map((item, idx) => {
                    return (
                      user?.userId === item?.userId && (
                        <ManagePaymentCard
                          data={item}
                          policies={policies}
                          key={idx}
                          isUpdated={isUpdated}
                          setIsUpdated={setIsUpdated}
                          setToastDetail={setToastDetail}
                        />
                      )
                    );
                  })}
                </div>
              </div>
            </>
          )}
        </div>
      </EverlakeLoadingOverlay>

      <AddPaymentMethod
        modalState={addPaymentModal}
        setModalState={setAddPaymentModal}
        selectedPolicy={policies[0]}
        setToastDetail={setToastDetail}
        portalReturnURL={`/payment/manage-payments`}
      />

      <GeneralPurposeDialog
        state={openDialog}
        setState={setOpenDialog}
        title={title}
        desc={message}
      />
    </>
  );
}
